/**
 *
 * Asynchronously loads the component for AdminPage
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./AdminPage"));
